import he from 'he';
import fp from 'lodash/fp';
import { connect } from 'react-redux';
import { lifecycle, withHandlers, withProps } from 'recompose';
import { bindActionCreators, compose } from 'redux';
import {
  fullName,
  getUserIndustryCpdCategorys,
  getUserIndustryGoals,
  isManager
} from '../../../../../services';
import {
  businessActions,
  businessSelector,
  queryTeamMembersSelector
} from '../../../../../state/modules/business';
import MultipleEntitiesTrainingPlans from '../partials/multi-entity-training-plans';
import { filterNonLegacy } from '../../../../../common/cpd-category-filter';

const mapStateToProps = (state) => ({
  business: businessSelector(state),
  teamMembersResult: queryTeamMembersSelector(state),
  teamMemberTrainingPlans: state.business.teamMemberTrainingPlans,
  isFetchingTeamMembers: state.business.isFetchingTeamMembers,
  taskStack: state.business.user.taskStack,
  setTrainingPlanSuccess:
    state.business.user.setBusinessUserTrainingPlanSuccess,
  profile: state.user.profile,
  industryProfiles: state.industry.industriesWithCpdCategorys
});

const mapDispatchToProps = (dispatch) => ({
  getTeamMemberTrainingPlans: bindActionCreators(
    businessActions.business.queryTeamMemberTrainingPlans,
    dispatch
  ),
  getTeamMembers: bindActionCreators(
    businessActions.business.queryTeamMembers,
    dispatch
  ),
  loadMoreMembers: bindActionCreators(
    businessActions.business.loadMoreTeamMembers,
    dispatch
  ),
  saveUserCpdCategorys: bindActionCreators(
    businessActions.business.user.setCpdCategorys,
    dispatch
  ),
  initTaskStack: bindActionCreators(
    businessActions.business.user.initTaskStack,
    dispatch
  )
});

export const UsersTrainingPlans = compose(
  connect(mapStateToProps, mapDispatchToProps),
  lifecycle({
    componentDidMount() {
      this.props.getTeamMemberTrainingPlans(this.props.business.id);
    }
  }),
  withProps(
    ({ business, teamMemberTrainingPlans, profile, industryProfiles }) => {
      const userIndustryCpdCategorys = getUserIndustryCpdCategorys(
        profile,
        industryProfiles
      );
      const userIndustryGoals = getUserIndustryGoals(profile, industryProfiles);
      const sortedCpdCategorys = fp.flow(
        filterNonLegacy,
        fp.sortBy('name'),
        (sorted) => {
          const parents = fp.filter(
            ({ parentCpdCategoryId }) => !parentCpdCategoryId
          )(sorted);
          const children = fp.filter(
            ({ parentCpdCategoryId }) => !!parentCpdCategoryId
          )(sorted);
          return parents.map((parent) =>
            [parent].concat(
              children.filter(
                (child) => child.parentCpdCategoryId === parent.id
              )
            )
          );
        },
        fp.flatten
      )(userIndustryCpdCategorys);
      return {
        overview: {
          business,
          trainingPlans: fp.sortBy(({ user }) => fp.lowerCase(fullName(user)))(
            teamMemberTrainingPlans
          ),
          cpdCategorys: sortedCpdCategorys,
          goals: userIndustryGoals
        }
      };
    }
  ),
  withHandlers({
    queryEntities:
      ({ getTeamMembers, business }) =>
      (filter) => {
        getTeamMembers(business.id, filter);
      },
    loadMoreEntities:
      ({ business, loadMoreMembers }) =>
      (filter) => {
        loadMoreMembers(business.id, filter);
      },
    saveCpdCategorys:
      ({ business, saveUserCpdCategorys }) =>
      (
        trainingPlan,
        entity,
        currentUserId,
        industryId,
        industryEntity,
        goals
      ) => {
        const planToSave = fp.map((plan) => ({
          ...plan,
          userId: entity.id
        }))(trainingPlan);
        saveUserCpdCategorys({
          cpdCategorys: planToSave,
          businessId: business.id,
          userId: entity.id,
          currentUserId: currentUserId,
          industryId: industryId,
          industry: industryEntity,
          goals
        });
      }
  }),
  withProps(({ teamMembersResult, isFetchingTeamMembers }) => ({
    entityTrainingPlans: fp.flow(
      fp.get('teamMembers'),
      fp.filter((member) => !isManager(member)),
      fp.map(({ user, cpdCategorys, industryUser, goals }) => ({
        trainingPlan: cpdCategorys,
        entity: {
          ...user,
          name: he.decode(fullName(user))
        },
        goals: fp.map(({ progressGoalId, points }) => ({
          goalId: progressGoalId,
          points
        }))(goals),
        industryEntity: industryUser
      }))
    )(teamMembersResult),
    entityQueryResult: teamMembersResult,
    isFetchingEntities: isFetchingTeamMembers
  }))
)(MultipleEntitiesTrainingPlans);



// WEBPACK FOOTER //
// ./src/containers/pages/app/account-settings/components/users-training-plans.js